/* eslint-env browser */
import { EMPTY_OBJ, EMPTY_STR } from '@lacele/const'
import { joinStrings } from '@lacele/utils'

let publicUrl = EMPTY_STR

export function setPublicUrl(publicUrlParam) {
    publicUrl = publicUrlParam || EMPTY_STR
}

function hasResponseBody(response) {
    return response.status !== 204
}

function parseResponseAndJSON(options, response) {
    if (response) {
        const result = {
            response
        }
        if (hasResponseBody(response)) {
            if (options.responseType === 'blob') {
                return response.blob().then((blob) => {
                    result.blob = blob
                    return result
                })
            }
            if (options.responseType === 'text') {
                return response.text().then((text) => {
                    result.text = text
                    return result
                })
            }
            return response.json().then((json) => {
                result.json = json
                return result
            })
        }
        return Promise.resolve(result)
    }
    return Promise.resolve(EMPTY_OBJ)
}

export function parseJSON(response) {
    if (response && hasResponseBody(response)) {
        return response.json()
    }
    return Promise.resolve(EMPTY_OBJ)
}

export function status2string(response) {
    return joinStrings(' - ', response.status, response.statusText)
}

export function checkStatus(response) {
    if (response.ok) {
        return response
    }
    const error = new Error(status2string(response))
    error.response = response
    throw error
}

export function fetchCheckStatus(url, options) {
    const {
        absoluteUrl,
        body,
        ...effectiveOptions
    } = options
    if (body && typeof body === 'object' && !(body instanceof FormData)) {
        effectiveOptions.body = JSON.stringify(body)
    } else {
        effectiveOptions.body = body
    }
    const effectiveUrl = absoluteUrl ? url : publicUrl + url
    return fetch(effectiveUrl, effectiveOptions)
        .then(checkStatus)
}

export default (url, options) => {
    const {
        includeResponse,
        ...effectiveOptions
    } = options
    return fetchCheckStatus(url, effectiveOptions).then((response) => {
        if (includeResponse) {
            return parseResponseAndJSON(options, response)
        }
        return parseJSON(response)
    })
}
